import { Layout } from '@utils/Layout';

export const maxBodyWidth = 1600;

export const mobileBreakpoint = 900;

export const topbarHeight = 60;
export const getFullHeightSectionHeight = (windowHeight: number, windowWidth: number) => (
  (windowWidth >= mobileBreakpoint) ? (
    windowHeight - topbarHeight
  ) : (
    windowHeight  
  )
);

export const largeLayout = new Layout(960, 12, 22);



// WEBPACK FOOTER //
// src/app/src/styles/layout.ts